<template>
  <b-container class="actions-container">
    <b-row>
      <b-col cols="12" class="title">
        <span>Next, select the system action to be taken once all conditions are met.</span>
        <span class="p-0" id="actions-info-popover">
          <i class="fa fa-info-circle gray-clr m-4" aria-hidden="true"></i>
        </span>
      </b-col>
      <b-popover target="actions-info-popover" triggers="hover" placement="right" :offset="70" :boundary="'viewport'">
        <template v-slot:content>
          <div class="actions-popover popover-font">
            Select the system action that will take place once the triggered event conditions have been met.
          </div>
          <ul class="popover-points popover-font">
            <!-- Need to replace text 'activity' with 'activity/packet' when 'Add/Remove A Packet' functionality gets implemeneted. -->
            <li>
              Adding an activity will automatically trigger the specified activity based on the schedule determined in the next steps.
            </li>
            <li>
              Notifying the research team allows you to send a customized message to selected role(s) within the research team once the triggered event conditions have been met.
            </li>
            <li>
              Removing an activity will prevent an already scheduled activity from being available to the participant/site once the triggered event conditions have been met.
            </li>
          </ul>
        </template>
      </b-popover>
    </b-row>
    <div class="action-panel">
      <b-row v-for="(action, a_index) in actions" v-bind:key="'action-configurations-' + a_index" class="d-flex align-items-center trigger-select">
        <b-col cols="12" class="">
          <!--  Select an Action Start-->
          <b-row class="d-flex align-items-center">
            <b-col cols="5" class="">
              <das-dropdown :options="getActionTypes(a_index)" :optionField="'text'" :valueField="'value'" :defaultText="'actionType'" :input="action.type" :id="`action-option-dropdown-${a_index}`" @selected-data="setActionType(action, a_index, $event)"> </das-dropdown>
            </b-col>
          </b-row>
          <!--  Select an Action Ends -->

          <!-- Add an activity / Remove an Activity starts -->
          <b-row class="d-flex align-items-center" v-if="action.type === 'addActivity' || action.type === 'removeActivity'">
            <b-col cols="5">
              <das-dropdown-search :options="getAllowedActivitiesList(a_index)" :optionField="'taskTitle'" :defaultText="'taskDetails'" :input="action.tasks" :actionData="action" :id="`add-remove-activity-dropdown-${a_index}`" @selected-data="setTaskDetails(action, a_index, $event)"> </das-dropdown-search>
            </b-col>
            <b-col cols="1" class="ml-auto" v-if="a_index > 0">
              <button class="btn btn-link color_red mb-11 pr-0" v-on:click="deleteAnotherAction(a_index)">
                <img height="32" width="32" src="static/img/light-gray-delete.svg" />
              </button>
            </b-col>
          </b-row>
          <!-- Add an activity / Remove an Activity ends -->

          <!-- Notify research team starts -->

          <notify-research-team-section v-if="action.type === 'notifySiteTeam'" :action="action" :researchTeamRoles="roles" :index="a_index" @selected-research-team-data="getSiteTeamMemberRoles(action, a_index, $event)" @delete-another-action="deleteAnotherAction(a_index)" @save-site-team-message="setSiteTeamDetails(action, a_index, $event)" />

          <!-- Notify research team ends -->
        </b-col>
        <b-col cols="12" class="divider-line" v-if="a_index + 1 < actions.length || (actions.length < DynamicSchedulingConstants.DYNAMIC_SCHEDULED_ACTIONS_LIMIT && showAddAnotherActionButton)"></b-col>
      </b-row>

      <!-- Add another action button starts -->
      <b-row>
        <b-col v-if="showAddAnotherActionButton && actions.length < DynamicSchedulingConstants.DYNAMIC_SCHEDULED_ACTIONS_LIMIT">
          <button class="dynamic-activity-scheduler-btn" @click="addAnotherAction()">
            Add Another Action
          </button>
        </b-col>
      </b-row>
      <!-- Add another action button ends -->
    </div>
  </b-container>
</template>
<script>
const DEFAULT_ACTION = {
  type: "",
  sequence: null,
  taskId: "",
  tasks: []
};

const ACTION_TYPES = [
  { value: "addActivity", text: "Add an Activity" },
  /* { value: 'addPacket', text: 'Add a Packet' }, */
  { value: "notifySiteTeam", text: "Notify Research Team" },
  { value: "removeActivity", text: "Remove an Activity" }
  /* { value: 'removePacket', text: 'Remove a Packet' }, */
];

import dasDropdown from "./dropdown.vue";
import { cloneDeep, pick } from "lodash";
import swal from "sweetalert2";
import dasDropdownSearch from "./dynamic-dropdown-search";
import NotifyResearchTeamSection from "./notify-research-team";
import * as DynamicSchedulingConstants from "@/constants/dynamicSchedulingConstants";

export default {
  name: "action-configuration-step",
  components: {
    dasDropdown,
    dasDropdownSearch,
    NotifyResearchTeamSection
  },
  props: {
    actionRelatedDetails: {
      type: Array,
      default: () => []
    },
    taskDetails: {
      type: [Object, String],
      default: null
    },
    editActionsData: {
      type: Array,
      defaultText: [],
      required: false
    },
    addOrEditMode: {
      type: String,
      defaultText: "add",
      required: false
    }
  },
  data() {
    return {
      actionTypes: [...ACTION_TYPES],
      roles: {
        siteTeam: [
          { text: "Principal Investigator", value: "Pi" },
          { text: "Sub-Investigator", value: "SubPi" },
          { text: "Study Coordinator", value: "StudyCoordinator" },
          /* { text: "Site-Data Lock", value: "SiteDataLock" }, */ {
            text: "Home Health",
            value: "HomeHealth"
          } /* { text: "Observer", value: "Observer" }, { text: "Call Center", value: "CallCenter" } */
        ],
        studyTeam: [
          { text: "Clinical Research Associate (Blinded)", value: "Cra" },
          { text: "Clinical Research Associate (Unblinded)", value: "CraUB" },
          { text: "Data Management", value: "Dm" },
          {
            text: "Quality",
            value: "Quality"
          } /* { text: "Study Admin", value: "StudyAdmin" }, { text: "System Admin", value: "SystemAdmin" } */
        ]
      },
      actions: [],
      showAddAnotherActionButton: false,
      DynamicSchedulingConstants: DynamicSchedulingConstants
    };
  },
  methods: {
    getSiteTeamMemberRoles(action, i, data) {
      let condt = null;

      if (action["message"] || action["message"] === "") {
        condt = pick(action, ["type", "sequence", "message"]);
      } else {
        condt = pick(action, ["type", "sequence"]);
      }

      condt["role"] = cloneDeep(data);
      this.actions[i] = condt;
      this.$forceUpdate();
      this.validateAction();
    },
    addAnotherAction() {
      this.actions && this.actions.push(cloneDeep(DEFAULT_ACTION));
      this.emitEventToDisableNextButton(true);
    },
    validateAction() {
      let disableNext = true;

      let action = null;

      for (let i = 0; i < this.actions.length; i++) {
        disableNext = true;
        action = this.actions[i];
        switch (action.type) {
          case "addActivity":
            if (action.tasks) {
              for (const task of action.tasks) {
                if (task.taskID && typeof task.taskID === "string") {
                  disableNext = false;
                }
              }
            }
            break;
          case "removeActivity":
            if (action.tasks) {
              for (const task of action.tasks) {
                if (task.taskID && typeof task.taskID === "string") {
                  disableNext = false;
                }
              }
            }
            break;
          case "notifySiteTeam":
            if (action.role && action.role.siteTeam && action.role.studyTeam && (action.role.siteTeam.length || action.role.studyTeam.length) && (action.message != null || action.message != undefined)) {
              disableNext = false;
            }
            break;
          default:
            break;
        }
        if (disableNext) {
          break;
        }
      }
      this.emitEventToDisableNextButton(disableNext);
    },
    deleteAnotherAction(index) {
      swal({
        title: "Are you sure you want to delete this system action?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Delete"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.actions && this.actions.splice(index, 1);
          this.validateAction();
        }
      });
    },
    setActionType(action, i, event) {
      if (this.actions[i].type && this.actions[i].type === event.value) {
        return null;
      }

      const condt = pick(action, ["type", "sequence"]);
      condt["type"] = event.value;
      condt["sequence"] = i + 1;
      // condt["tasks"] = this.getAllowedActivitiesList( i );
      this.actions[i] = condt;
      this.$forceUpdate();
      this.validateAction();
    },
    setTaskDetails(action, i, event) {
      if (this.actions[i].type && this.actions[i].type === event.value) {
        return null;
      }

      const condt = pick(action, ["type", "sequence", "tasks"]);
      condt["tasks"] = event.map(task => ({
        ...task,
        taskID: task.taskID,
        taskTitle: task.taskTitle,
        taskType: task.taskType,
        taskFileName: task.taskID,
        taskClassName: task.taskClassName,
        facingType: task.facingType,
        completePermissions: task.CompletedBy,
        viewPermissions: task.viewBy,
        segmentId: null
      }));
      this.actions[i] = condt;
      this.$forceUpdate();
      this.validateAction();
    },
    setSiteTeamDetails(action, i, data) {
      const condt = pick(action, ["type", "sequence", "role"]);

      condt["message"] = cloneDeep(data);
      this.actions[i] = condt;
      this.$forceUpdate();
      this.validateAction();
    },
    emitEventToDisableNextButton(value) {
      this.showAddAnotherActionButton = !value;
      this.$emit("disableNextButton", value);
    },
    getAllowedActivitiesList(index) {
      /* This is for not showing activities that are already once selected. */

      let activityList = cloneDeep(this.actionRelatedDetails);
      const actions = this.actions;

      for (let i = 0; i < actions.length; i++) {
        if (actions[i].type === "addActivity" || actions[i].type === "removeActivity") {
          for (let a = 0; a < this.actionRelatedDetails.length; a++) {
            if (!(actions[i] && actions[i].tasks && actions[i].tasks.length && actions[i].tasks[0] && actions[i].tasks[0].taskID)) {
              break;
            }

            if (index === i) {
              break;
            }

            const tasksLength = actions[i].tasks.length;

            for (let j = 0; j < tasksLength; j++) {
              if (actions[i].tasks[j].taskID === this.actionRelatedDetails[a].taskID) {
                activityList = activityList.filter(a => a.taskID !== actions[i].tasks[j].taskID);
                break;
              }
            }
          }
        }
      }
      return activityList;
    },
    getActionTypes(index) {
      const a = this.actionTypes.filter(actionType => {
        let isType = false;

        let countNotifySiteTeamActions = 0;
        for (let i = 0; i < this.actions.length; i++) {
          if (i != index && this.actions[i].type == actionType.value && (this.actions[i].type == "addActivity" || this.actions[i].type == "removeActivity")) {
            // To restrict 'Add an Activity'/'Remove an Activity' not to appear more than once.
            isType = true;
            break;
          } else if (this.actions[i].type == actionType.value && this.actions[i].type == "notifySiteTeam") {
            countNotifySiteTeamActions++;
            if (i != index) {
              if (countNotifySiteTeamActions > this.DynamicSchedulingConstants.NOTIFY_RESEARCH_TEAM_SELECTION_LIMIT) {
                // To restrict to not let to add more than 25 notify site team actions.
                this.$toastr.error("The number of Notify Research Team configurations cannot be greater than 25.");
                this.actions[i] = cloneDeep(DEFAULT_ACTION);
                isType = true;
                break;
              }
            }
          }
        }
        if (isType) {
          return false;
        } else {
          return true;
        }
      });
      return a;
    }
  },
  computed: {
    isAdd() {
      return this.addOrEditMode === "add";
    },
    isEdit() {
      return this.addOrEditMode === "edit";
    }
  },
  watch: {
    editActionsData: {
      deep: true,
      immediate: true,
      handler: function(newData) {
        this.actions = [];
        if (newData && newData.length) {
          this.actions = cloneDeep(newData);
          this.showAddAnotherActionButton = true;
        } else {
          this.actions && this.actions.push(cloneDeep(DEFAULT_ACTION));
        }
        this.$forceUpdate();
      }
    }
  }
};
</script>
<style lang="scss">
.actions-container {
  select,
  .select-custom {
    background-position: right 50% !important;
    background-repeat: no-repeat;
    background-image: url(/static/img/arrow-down.png);
    position: relative !important;
    border-radius: 4px;
    cursor: pointer;
    &::after {
      transform: rotate(90deg);
    }
    .dropdown.icon {
      right: -3px !important;
      top: 5px !important;
      &:before {
        content: url(/static/img/arrow-down.png);
      }
    }
  }
  & .options-cls {
    position: absolute !important;
    top: 0 !important;
  }

  .action-panel {
    padding: 0 0 160px;
    max-height: 450px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  padding: 21px 0;
  max-height: 507px;
  & .title {
    margin-bottom: 11px;
    padding-left: 28px;
    span {
      font-family: RobotoRegular;
      font-size: 16px;
      color: #000;
    }
    & .gray-clr {
      color: #bac1c4;
      margin-left: 4px;
      font-size: 16px;
    }
  }
  & .m-top-15 {
    margin-top: 15px;
  }
  & .pad-top-btm-15 {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  & .padding-sideways-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  & .gray-icon {
    padding: 13%;
    background-color: #dfe8ec;
    color: #acb5b9;
    font-size: 20px;
    font-weight: 500;
    border-radius: 3px;
  }
  & .color_red {
    padding-top: 0px;

    img {
      vertical-align: middle;
      padding: 2px;
      border: 1px solid #d3dfe4;
      background-color: rgba(211, 223, 228, 0.8);
      opacity: 0.8;
      height: 100%;
      border-radius: 3px;
      &:hover {
        cursor: pointer;
        box-shadow: 0 1px 0px 0 rgba(230, 230, 230, 2%), 0 1px 9px 0 rgba(230, 230, 230, 19%);
      }
      &:active {
        cursor: pointer;
        box-shadow: none;
      }
    }
  }
  & .divider-line {
    margin-top: 13px;
    margin-bottom: 28px;
    background-color: #c5d1d6;
    height: 1px;
    width: 100%;
  }
  & .dynamic-activity-scheduler-btn {
    border-radius: 4px;
    border: solid 1px #4c8ce4;
    background: #fff;
    font-family: "RobotoRegular";
    font-size: 15px;
    color: #4c8ce4;
    padding: 3px 12px 4px 12px;
    position: relative;
    margin-left: 15px;
    &:hover {
      cursor: pointer;
      color: #649be8;
      border: solid 1px #649be8;
      box-shadow: 0 1px 0px 0 rgba(230, 230, 230, 2%), 0 1px 9px 0 rgba(230, 230, 230, 19%);
    }
    &:active {
      cursor: pointer;
      color: #4c8ce4;
      border: solid 1px #4c8ce4;
      box-shadow: none;
    }
  }
  .custom-message-textarea {
    margin-bottom: 15px;
    resize: none;
  }
  .message-box {
    padding: 10px;
    border-radius: 3px;
    border: solid 1px #d3dfe4;
    color: #666669;
    font-size: 14px;
    word-break: break-word;
  }
  .text-counter {
    position: absolute;
    right: 95px;
    bottom: 30px;
    color: #666669;
    font-size: 12px;
    opacity: 0.5;
  }
  .message-save-btn {
    position: absolute;
    right: 25px;
    bottom: 25px;
    padding: 5px 10px;
    border-radius: 4px;
    background-color: #4c8ce4;
    color: #fff;
    border: none;
    cursor: pointer;
  }
}

.action-panel::-webkit-scrollbar-thumb {
  background-color: #c4c4c4;
  border-radius: 4px;
  height: 50px;
  border: 3px solid transparent;
}

.action-panel::-webkit-scrollbar-track {
  background: transparent;
}

.action-panel::-webkit-scrollbar {
  width: 6px;
}

.popover-font {
  font-size: 13px;
  font-family: "RobotoRegular";
  color: #000;
}

.actions-popover {
  padding: 0.5em 0.3em 0.5em 0.3em;
}

.popover-points {
  padding: 0em 0.5em 0em 2.2em;
  margin: 0em 0em 0.4em 0em;
  list-style-position: outside;
  & > li:not(:last-child) {
    margin-bottom: 0.5em;
  }
}
</style>
